/**
 * Server list from Netflix clone VideoPlayer. Used only by the movies feature.
 */

export const DEFAULT_SERVERS = [
  {serverurl: 'https://vidlink.pro/movie/'},
  {serverurl: 'https://vidlink.pro/tv/'},
  {serverurl: 'https://vidsrc-embed.ru/embed/movie/'},
  {serverurl: 'https://vidsrc-embed.ru/embed/tv/'},
  {serverurl: 'https://vidsrcme.ru/embed/movie'},
  {serverurl: 'https://vidsrcme.ru/embed/tv'},
  {serverurl: 'https://vidnest.fun/movie/'},
  {serverurl: 'https://vidnest.fun/tv/'},
  {serverurl: 'https://vidup.to/movie/'},
  {serverurl: 'https://vidup.to/tv/'},
  {serverurl: 'https://vidcore.net/movie/'},
  {serverurl: 'https://vidcore.net/tv/'},
]

export function filterServers(
  servers: {serverurl: string}[],
  type: 'movie' | 'tv',
) {
  return servers.filter(s => {
    const u = s.serverurl.toLowerCase()
    if (type === 'movie') return u.includes('/movie') || u.includes('movie')
    return u.includes('/tv') || u.includes('tv')
  })
}
